import { createContext } from 'react';
export const ScrollIntoViewContext = /*#__PURE__*/createContext({
  containerRef: undefined,
  enabled: false,
  scrollToElement: () => {}
});
//# sourceMappingURL=scroll-into-view-context.js.map